import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from './shared/interceptor/auth.interceptor';

const antDesignIcons = AllIcons as Record<string, IconDefinition>;
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  (key) => antDesignIcons[key]
);

export const appConfig: ApplicationConfig = {
  // providers: [
  //   provideZoneChangeDetection({ eventCoalescing: true }),
  //   { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
  //   JwtHelperService,
  //   provideToastr({
  //     timeOut: 10000,
  //     positionClass: 'toast-top-center',
  //     maxOpened: 1,
  //     autoDismiss: true,
  //     preventDuplicates: true,
  //   }),
  //   provideRouter(routes),
  //   provideClientHydration(withEventReplay()),
  //   provideHttpClient(),
  //   provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  //   provideNzIcons(icons),
  //   provideAnimations(),
  // ],

  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    // provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    // provideMessaging(() => getMessaging()),
    provideHttpClient(),
    provideNzIcons(icons), //nz-icons
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,

    // Add this for SSR compatibility
    { provide: 'REQUEST', useValue: {} },
    { provide: 'RESPONSE', useValue: {} },
    // provideNzI18n(en_US),
    // importProvidersFrom(FormsModule),
    // provideAnimationsAsync(),
    provideHttpClient(),
  ],
};
